import AemAccordion, {AccordionEditConfig} from './AemAccordion';
import {MapTo} from '@adobe/aem-react-editable-components';

export default MapTo('cob-corp-acquisition/components/creditonebank/accordion')(AemAccordion, AccordionEditConfig);